module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-600.b13e95a6.woff";